module.exports = __webpack_public_path__ + "img/upload-event-banner.af27a6b4.png";